import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from 'src/app/shared/shared.module';
import { DiagnosisCodeManagementListComponent } from './components/diagnosis-management/diagnosis-code-management-list/diagnosis-code-management-list.component';
import { UploadFileComponent } from './components/upload-file/upload-file.component';
import { MasterAddEditComponent } from './components/master-add-edit/master-add-edit.component';
import { MasterManagementDetailViewComponent } from './components/master-management-detail-view/master-management-detail-view.component';
import { AllergyCodeManagementListComponent } from './components/allergy-management/allergy-code-management-list/allergy-code-management-list.component';

const routes: Routes = [
  { path: 'diagnosis-management', component: DiagnosisCodeManagementListComponent},
  { path: 'allergy-management', component: AllergyCodeManagementListComponent},

  { path: 'diagnosis-detail-view/:diaganosisVersionId', component: MasterManagementDetailViewComponent},
  { path: 'allergy-detail-view/:allergyVersionId', component: MasterManagementDetailViewComponent},

  { path: '', redirectTo: 'diagnosis-management' },

]

@NgModule({
  declarations: [
    DiagnosisCodeManagementListComponent,
    UploadFileComponent,
    MasterAddEditComponent,
    MasterManagementDetailViewComponent,
    AllergyCodeManagementListComponent
  ],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
  ]
})
export class MasterManagementModule { }
